export const Role = {
  Owner: 'Owner',
  Admin: 'Administrator',
  User: 'User',
  SuperAdmin: 'SuperAdmin',
};
